import { render, staticRenderFns } from "./CompetitionListLatelyLayout.vue?vue&type=template&id=41f915e4&scoped=true"
import script from "./CompetitionListLatelyLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionListLatelyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f915e4",
  null
  
)

export default component.exports